import React, {useRef} from 'react'
import {Text} from "atmosfair-ui";
import {AllActivityTypes, AllActivityTypesArray} from "../../../../types-enums/activity";
import './styles.css'
import {
    JOURNEY_DND_CONTAINER_WHICH_VIEW
} from "../../../../container/journey/journey-dnd-container/JourneyDnDContainer";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {getActivityShortTitleAndType} from "../../../../utils/string/common";
import {COMMON_COLOR} from "../../common";
import {treatActivityOnMoveLikeGroupedActivity} from '../../journey-overview/common';

export interface DraggingActivityListItemProps {
    activity: AllActivityTypes,
    whichView: JOURNEY_DND_CONTAINER_WHICH_VIEW
    activities: AllActivityTypesArray,
    altKeyPressed: boolean,
}


const DraggingActivityListItem = ({
                                      activity,
                                      activities,
                                      altKeyPressed,
                                      whichView
                                  }: DraggingActivityListItemProps) => {
    const {i18n} = useTranslation()
    const {activityTypeString, activityString} = useRef(getActivityShortTitleAndType(activity, i18n)).current

    const _setContainerClasses = () => {
        switch (whichView) {
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.createFromTravelComponents:
                return 'dragging-activity-create-from-travel-components'
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.journeyOverview:
                return 'dragging-activity-journey-overview'
            default:
                whichView satisfies never;
        }
    }

    const _setTextColor = () => {
        switch (whichView) {
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.createFromTravelComponents:
                return COMMON_COLOR
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.journeyOverview:
                return 'primary'
            default:
                whichView satisfies never;
        }
    }

    const _renderActivityText = (key: number) => <div key={key} className={"dragging-activity-list-item-text-wrapper"}>
        <Text color={_setTextColor()}>{activityTypeString}</Text>
        <Text color={_setTextColor()}>—</Text>
        <Text color={_setTextColor()}>{activityString}</Text>
    </div>

    const _renderContent = () => {
        switch (whichView) {
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.createFromTravelComponents:
                return _renderActivityText(1)
            case JOURNEY_DND_CONTAINER_WHICH_VIEW.journeyOverview:
                const {common: {groupId}} = activity
                if (altKeyPressed) return _renderActivityText(1)
                if (groupId || treatActivityOnMoveLikeGroupedActivity(activity)) return activities
                    .filter(activity => activity.common.groupId === groupId)
                    .map((_, index) => _renderActivityText(index))
                // if groupId === null
                return _renderActivityText(1)

            default:
                whichView satisfies never;
        }
    }

    return <div
        className={clsx('common-dragging-activity-list-item-container', _setContainerClasses())}>
        {_renderContent()}
    </div>
}

export default DraggingActivityListItem